import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '威红云',
  pwa: true,
  logo: 'https://xcyobs.obs.cn-east-3.myhuaweicloud.com/webicon/weihongyun.png',
  iconfontUrl: '',
  token: {
    sider: {
      colorMenuBackground: '#fff',
      colorTextMenuSelected: '#1664FF',
      colorBgMenuItemSelected: '#ECF3FF',
    }
  },
};

export default Settings;
